import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { DefaultError } from 'src/chrome'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
// @src imports
import { getGifts } from 'src/graphql'
import { useQueries } from 'src/hooks'

interface Props {
  giftsQuery: ReturnType<typeof getGifts>
}

const NotFound: React.FC<Props> = props => {
  const { giftsQuery } = props

  const [gifts] = useQueries(giftsQuery)

  if (gifts.length) return null

  return <Text type="body">No Gifts Found</Text>
}

export default suspenseBoundary({
  component: NotFound,
  unresolved: <></>,
  failure: DefaultError,
})
